import React, { useState } from 'react';
import Science from '@mui/icons-material/Science';
import { Button } from '@/ui';
import TestVendorRequestModal from './TestVendorRequestModal';
import type { TestVendorRequestButtonProps } from '../../../../types/testVendorRequest.types';

/**
 * TestVendorRequestButton - Button that opens the TestVendorRequestModal.
 */
const TestVendorRequestButton: React.FC<TestVendorRequestButtonProps> = ({ fieldMapping, prefix, initialValues }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggle = (): void => setIsOpen((prev) => !prev);

  return (
    <>
      <Button color='info' onClick={toggle} data-testid='test-post-open-button' startIcon={<Science />}>
        Test POST
      </Button>
      {isOpen && (
        <TestVendorRequestModal
          isOpen={isOpen}
          toggle={toggle}
          fieldMapping={fieldMapping}
          prefix={prefix}
          initialValues={initialValues}
        />
      )}
    </>
  );
};

export default TestVendorRequestButton;
